module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Airpods-9fc8d13f8e18ac504d9713976c57a0e8.svg";